// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2VJ14","clinicsSelect":"TableHeading_clinicsSelect__leu9a"};